
import React, { ReactNode, useState } from "react";
import { useLocation } from 'react-router-dom';

import { Navbar, Offcanvas, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// icons 
import { FaCalendarAlt, FaPowerOff, FaTools, FaShippingFast, FaCar } from 'react-icons/fa';
import { FaPeopleGroup } from "react-icons/fa6";

import { GoVerified } from 'react-icons/go';
import { BsPinMap, BsFillFileSpreadsheetFill, BsFunnelFill, BsBoxFill } from "react-icons/bs";
import { MdGroupAdd, MdDashboard, MdOutlineSettingsInputAntenna, MdSupportAgent } from "react-icons/md";
// import { TbDeviceNintendo } from "react-icons/tb";
import { AiOutlineMenu } from 'react-icons/ai';
import { AiFillCaretRight } from "react-icons/ai";
import { PiCoinsFill } from "react-icons/pi";
// import {IoMdPersonAdd } from "react-icons/io"; 
import { LuPackagePlus } from "react-icons/lu";
import { Session, ProductName } from './Utils';


type MenuItemProp = {
  url: string;
  name: string;
  icon: string;
  sub_menu?: Record<string, string>[];
}

const SHARED_LOGOUT = '/logout';

const IconList: Record<string, ReactNode> = {
  pin: <BsPinMap />,
  fill_spread: <BsFillFileSpreadsheetFill />,
  group_add: <MdGroupAdd size={22} />,
  tools: <FaTools />,
  power_off: <FaPowerOff />,
  dash: <MdDashboard size={20} /> , 
  package : <BsBoxFill size={20}/>,
  package_add: <LuPackagePlus size={20} />,
  carret_side: <AiFillCaretRight size={20} />, 
  coins: <PiCoinsFill size={20} />, 
  schedules : <FaCalendarAlt  size={20} />, 
  shipment: <FaShippingFast size={20} />,
  vehicle: <FaCar size={20} />, 
  device: <MdOutlineSettingsInputAntenna />, 
  people: <FaPeopleGroup size={20} /> , 
  agent: <MdSupportAgent size={20} />
   
}
 
export {IconList} 


function MenuComp() {

  const current_map: MenuItemProp[] = JSON.parse(Session.get('menu'));
  
  return (<>
    <Navbar bg="blue" expand={false}
      style={{borderBottom: "4px solid #ddd" }}>
      <div className='col-md-4'>
        <Navbar.Toggle
          className="btn btn-primary text-white"
          style={{ padding: '5px 10px' }}
          aria-controls="menu_bar">
          <AiOutlineMenu />
        </Navbar.Toggle>
        <Navbar.Brand href="/#/map">
          <h4 style={{ display: 'inline' }} className="montsert-bold"> 
            <ProductName size="20px" />
            <sup>
              {
                Session.get('map_type') === '1' ? (
                  <GoVerified
                    className="text-success"
                    title="tracking with google map"
                    size={15}
                  />
                ) : (
                  <GoVerified
                    title="tracking with open map"
                    className="text-warning"
                    size={15}
                  />
                )
              }
            </sup>
          </h4>
        </Navbar.Brand>
      </div>
      <div className="col-md-8 right">
        <p className="blue-text montsert-bold">
          Welcome &nbsp; {Session.get('username')}! &nbsp;
          <Link className="blue-text nodecor" title="click to logout" to={SHARED_LOGOUT}>
            <FaPowerOff size={15} />
          </Link>
        </p>
      </div>

      <Navbar.Offcanvas
        id="menu_bar"
        aria-labelledby="menu_sec"
        placement="start"
        className={'bg-light'}
      >
        <Offcanvas.Header closeButton style={{ borderBottom: "4px solid #ddd" }}>
          <Offcanvas.Title id="menu_sec">
            {/* <b className="theme_blue_text"> Maptrackapp </b> <br />  */}            
            <p className="mb-0">
              <ProductName size="25px" />
            </p>
            
            <span style={{ fontSize: '12px', color: '#666' }}>
              <i> fleets, logistics and tracking...</i>
            </span>

          </Offcanvas.Title>

        </Offcanvas.Header>

        <Offcanvas.Body>
          <Nav className="nav nav-pills justify-content-end flex-grow-1 pe-3">
            {
              current_map.map((item, idx) => {
                  return <MenuListItem {...item} key={`mnu-${idx}`} />

              })
            }
          </Nav>

        </Offcanvas.Body>
      </Navbar.Offcanvas>

    </Navbar>

  </>
  );
}

export default MenuComp;


const MenuListItem = ({ url, name, icon, sub_menu }: MenuItemProp) => {

  const loc = useLocation();
  let cls = "";
  
  const [show, toggleState] = useState(false); 

  if (url.includes(loc.pathname)) {
    cls += "active"
  }
  
  let cls_style = 'nav nav-pills justify-content-end flex-grow-1 pe-3 d-none' ;
  
  if (show){
     cls_style = 'nav nav-pills justify-content-end flex-grow-1 pe-3'
  }  


  if (sub_menu !== undefined && sub_menu.length > 0){

    return (
      
        <Link to={'#'} onClick={()=> toggleState(!show)}>
            
            <span className="d-flex justify-content-between items-center"> 
              <span> {IconList[icon] } {' '} {name} </span> <span> {IconList['carret_side']}  </span> 
            </span>
            
            <Nav className={cls_style}>              
              {
                sub_menu?.map( (itm , idx) =>           
                  <Link to={itm.url} key={`inn_${idx}`}>
                    {IconList[itm.icon]} {' '} {itm.name}
                  </Link> ) 
              }
            </Nav>
            
        </Link>

    )
  }


  return <Link to={url} className={cls}> {IconList[icon] } {' '} {name} </Link> 

}

type PageTitleType = {

  title?: string,
  children?: JSX.Element | React.ReactNode[];
  filter?: boolean;
  filterfunc?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}
export const PageTitle = (
  { title, filter, filterfunc, children }: PageTitleType
) => {

  return (
    <div className='row mb-4'>
      <div className="col-md-6 p-3">

        {
          title ? <h2 className="montsert-bold"> {title} </h2> : (
            React.Children.map(children, (child) => {
              if (React.isValidElement(child)) {
                // @ts-ignore
                return React.cloneElement(child, { map });
              }
            })
          )
        }
        <hr style={{ border: "2px dotted #ccc" }} />

      </div>
      {
        filter ? (
          <div className="col-md-6 p-3">
            <div className="d-flex justify-content-end">
              <div className="d-grid gap-2 col-4">
                <button className="btn btn-light" onClick={filterfunc}>
                  <BsFunnelFill size={20} /> Advance Option
                </button>
              </div>
            </div>
          </div>
        ) : null
      }

    </div>
  )
} 
